import { Component, input, OnInit } from '@angular/core';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { add, scale } from '@shared/vector.utils';
import { LpParallaxCanvasComponent } from '@typings/lp/generated';
import { Vector2CanvasNormalized } from '@typings/vectors';

@Component({
  selector: 'lp-parallax-canvas-component',
  imports: [],
  templateUrl: './lp-parallax-canvas-component.component.html',
  styleUrl: './lp-parallax-canvas-component.component.css',
})
export class LpParallaxCanvasComponentComponent implements OnInit {
  comp = input.required<LpParallaxCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  ngOnInit(): void {
    this.context().transformPosition(
      (position, origin) => add(position, scale(scale(origin, -1), this.comp().speed)) as Vector2CanvasNormalized,
    );
  }
}
